module.exports = "/_next/static/images/gq-1f78740d5e97927861dfff87f50a3970.svg";